import { render } from "./dynamic.vue?vue&type=template&id=4203108f&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"

import "./dynamic.vue?vue&type=style&index=0&id=4203108f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4203108f"

export default script